<template>
	<v-dialog v-if="exibirModal" v-model="exibirModal" scrollable persistent :max-width="maxWidth" @keydown.enter="$emit('keydown-enter')">
		<v-card>
			<slot name="title">
				<v-card-title class="text-subtitle primary white--text thin font-weight-bold">
					<span :class="{ 'texto-titulo': $vuetify.breakpoint.mobile }">{{ titulo }}</span>
					<v-spacer></v-spacer>
					<v-btn id="closeModal" icon :class="{ 'close-modal-mobile': $vuetify.breakpoint.mobile }" @click="$emit('close')">
						<v-icon size="20" color="white">close</v-icon>
					</v-btn>
				</v-card-title>
			</slot>

			<v-card-text class="pa-0">
				<slot name="body">Texto do Modal</slot>
			</v-card-text>

			<slot name="actions"></slot>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'modal',
	props: {
		exibir: {
			type: Boolean,
		},
		titulo: {
			type: String,
			default: '',
		},
		maxWidth: {
			type: [Number, String],
			default: 1000,
		},
		minHeight: {
			type: [Number, String],
			default: null,
		},
	},
	computed: {
		exibirModal() {
			return this.exibir
		},
	},
}
</script>

<style scoped>
.v-dialog .texto-titulo {
	width: 75%;
	text-align: left;
}

.v-dialog .close-modal-mobile {
	position: absolute !important;
	right: 20px !important;
}

.v-dialog .v-card__title {
	word-break: break-word;
}

.modal-title {
	word-break: break-word;
}
</style>
